'use strict';
import Routes from '@expressive-analytics/vue-routes'
var req = require.context("./",true,/.vue$/)
req.keys().forEach(function(key){
  let k = key.match(/\.\/([^\.]+)/)[1]
  Routes.components[k] = ()=>import(''+key)
});
